var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64991 4.52519L5.35005 7.82505C5.12224 8.05284 5.12224 8.42215 5.35005 8.65C5.57786 8.87779 5.94721 8.87779 6.175 8.65L9.47486 5.35015C10.1582 4.66673 10.1582 3.55869 9.47486 2.87527C8.79143 2.19186 7.68339 2.19186 6.99995 2.87527L3.70014 6.17509C2.56111 7.31411 2.56111 9.16088 3.70014 10.2999C4.83916 11.4389 6.68589 11.4389 7.8249 10.2999L11.1248 7.00004L11.9497 7.82505L8.64991 11.1248C7.05525 12.7195 4.46982 12.7195 2.87518 11.1248C1.28054 9.53019 1.28054 6.9448 2.87518 5.35015L6.175 2.05032C7.31402 0.911288 9.1608 0.911288 10.2998 2.05032C11.4388 3.18934 11.4388 5.03608 10.2998 6.17509L6.99995 9.47495C6.31658 10.1584 5.20851 10.1584 4.5251 9.47495C3.84168 8.79152 3.84168 7.68347 4.5251 7.00004L7.8249 3.70023L8.64991 4.52519Z",
    fill: "#3B3B3B",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/attachment-icon.fef8bb5073a3e28c88e7dd1d659ecad5.svg";
export { ForwardRef as ReactComponent };